import { useAppDispatch } from "core/utils";
import { useLocation } from "react-router";

import { ContractVirtualCreateForm } from "src/app/features/Contract/components/forms/ContractVirtualCreateForm";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { CancelButton } from "../../../../components/FeatureButtons/CancelButton";
import { OkButton } from "../../../../components/FeatureButtons/OkButton";
import { SubmitButton } from "../../../../components/FeatureButtons/SubmitButton";
import { useFormSubmitTrigger } from "../../../../components/Form/hooks/useFormSubmitTrigger";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NavigationStateWithReturnTo } from "../../../../core/router/navigation/returnTo";
import { BASE_PATH, FORM_ACTION } from "../../../../core/router/types/routerTypes";
import { setDefaultActiveKey } from "../../../../core/setup/redux/state/tabs/tabState";

export const ContractVirtualCreateFormPage = () => {
    const { runSubmit, formAction, triggerSubmit, triggerOk } = useFormSubmitTrigger();
    const dispatch = useAppDispatch();
    const location = useLocation();

    // Only restore the Sites "contracts" tab when we have come from Site edit page (i.e. this create form was opened from Sites)
    const returnsToSiteEdit = ((location.state as NavigationStateWithReturnTo | null)?.returnTo?.pathname ?? "").startsWith(
        `${BASE_PATH}/${ResourceName.SITES}/${FORM_ACTION.EDIT}/`,
    );
    const setTabsDefaultBeforeBack = () => {
        if (returnsToSiteEdit) dispatch(setDefaultActiveKey("sites_contracts"));
    };

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.contractVirtualCreateFormPage" />
                <ActionBar>
                    <OkButton isDisabled={false} onClick={triggerOk} onBeforeNavigate={setTabsDefaultBeforeBack} />
                    <SubmitButton isDisabled={false} onClick={triggerSubmit} />
                    <CancelButton
                        isDisabled={false}
                        url={`${BASE_PATH}/${ResourceName.CONTRACTS}`}
                        onBeforeNavigate={setTabsDefaultBeforeBack}
                    />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <ContractVirtualCreateForm runSubmit={runSubmit} formAction={formAction} />
            </FPageContent>
        </FPage>
    );
};
